module.exports = __webpack_public_path__ + "static/img/18.681cae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/18.png
// module id = 56Le
// module chunks = 1